import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Trophy, Trash2, Share2, Download } from 'lucide-react';

const Leaderboard = ({ results = [], onClear, onExportCSV }) => {
  const { t } = useLanguage();

  const getRankClass = (index) => {
    if (index === 0) return 'gold';
    if (index === 1) return 'silver';
    if (index === 2) return 'bronze';
    return 'default';
  };

  const handleShare = async () => {
    if (results.length === 0) return;
    
    const text = results.map((r, i) => `${i + 1}. ${r.text}`).join('\n');
    const shareText = `🎡 wheel.expert Results:\n${text}`;
    
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Wheel Results',
          text: shareText
        });
      } catch (err) {
        // User cancelled
      }
    } else {
      // Copy to clipboard
      try {
        await navigator.clipboard.writeText(shareText);
        // Could add toast here
      } catch (err) {
        const textArea = document.createElement('textarea');
        textArea.value = shareText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
    }
  };

  if (results.length === 0) {
    return null;
  }

  return (
    <div className="leaderboard-panel" data-testid="leaderboard">
      <div className="leaderboard-header">
        <h3>
          <Trophy size={18} />
          Results Order
        </h3>
        <div className="leaderboard-actions">
          <button
            onClick={handleShare}
            className="leaderboard-btn"
            aria-label="Share results"
            title="Share results"
            data-testid="share-results-btn"
          >
            <Share2 size={16} />
          </button>
          {onExportCSV && (
            <button
              onClick={onExportCSV}
              className="leaderboard-btn"
              aria-label="Download CSV"
              title="Download as CSV"
              data-testid="export-csv-btn"
            >
              <Download size={16} />
            </button>
          )}
          <button
            onClick={onClear}
            className="leaderboard-btn leaderboard-clear"
            aria-label="Clear results"
            title="Clear all results"
          >
            <Trash2 size={16} />
          </button>
        </div>
      </div>

      <ol className="leaderboard-list" role="list">
        {results.map((result, index) => (
          <li key={`${result.id}-${index}`} className="leaderboard-item">
            <span className={`leaderboard-rank ${getRankClass(index)}`}>
              {index + 1}
            </span>
            <span 
              className="leaderboard-color" 
              style={{ backgroundColor: result.color }}
              aria-hidden="true"
            />
            <span className="leaderboard-name">{result.text}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Leaderboard;
